import { render, staticRenderFns } from "./ProfileApplications.vue?vue&type=template&id=40a95418&"
import script from "./ProfileApplications.vue?vue&type=script&lang=ts&"
export * from "./ProfileApplications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports